import React, { useEffect } from "react";
import "./EndScreen.css";
import Score from "./Score";

interface IEndMessageProps {
  won: boolean;
  drops: Record<string, number>;
  coin: number;
}

const HARD_MODE_MESSAGE = "Hard Mode unlocked (levels 9 & 10 are playable)";
export default function EndMessage(props: IEndMessageProps) {
  const { won, ...scoreProps } = props;
  const onClick = () => {
    document.location.reload();
  };

  useEffect(() => {
    const isHardMode = localStorage.getItem("very-very-hard");
    if (won && isHardMode !== "true") localStorage.setItem("very-very-hard", "true");
  }, [won]);

  return (
    <div className="end-message">
      <h3>{won ? "Congratulations" : "Game Over"}</h3>
      {won && <h4>{HARD_MODE_MESSAGE}</h4>}
      <Score {...scoreProps} />
      <button type="button" onClick={onClick}>
        Restart
      </button>
      <h5>Press [Space] to try again</h5>
    </div>
  );
}
